var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('placeholders-form',{attrs:{"data":_vm.placeholder,"title":_vm.$t('searchSuggestions.edit.title', { name: _vm.placeholder ? _vm.placeholder.name : ''}),"submit-loading":_vm.submitLoading},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }